import { useEffect, useState } from "react";
import { Col, Nav, NavItem, NavLink, Row, TabContent } from "reactstrap";
import { toast } from "react-toastify";
import AccessControl from "./Tabs/AccessControl";
import AuditTab from "./Tabs/Audit";
import SessionsTab from "./Tabs/Sessions";
import OverviewTab from "./Tabs/Overview";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import { get } from "../../../../utils/helpers/api";
import AuthenticationTab from "./Tabs/Authentication";
import { useTranslation } from "react-i18next";
import LoginTab from "./Tabs/Login";
import './styles.css';

function SecurityPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  const [loginLogsData, setLoginLogsData] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  const [activeDevices, setActiveDevices] = useState([]);

  const getSettings = async () => {
    const data = await get('/settings/security');
    if(data?.success) {
      setLoginLogsData(data.login_logs);
      setSettingsData(data.company_settings);
      setActiveDevices(data.active_devices);
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
  }

  useEffect(() => {
    getSettings();
  }, []);

  const tabs = [
    { id: 'overview',       label: t('security.overview')        },
    { id: 'authentication', label: t('security.authentication')  },
    { id: 'sessions',       label: t('security.sessions')        },
    { id: 'login-security', label: t('security.loginSecurity')   },
    { id: 'access-control', label: t('security.accessControl')   },
    { id: 'audit',          label: t('security.auditLog')        },
  ];

  console.log('activeDevices', activeDevices);

  return (
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('security.title')} />

        <div className="subheader-page-content scrollable">
        <p className="text-muted mb-4">{t('security.subtitle')}</p>

        <Row className="align-items-start">

          {/* Left nav */}
          <Col lg="2">
            <Nav pills vertical className="flex-column sec-nav">
              {tabs.map(tab => (
                <NavItem key={tab.id}>
                  <NavLink active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)} className="cursor-pointer">
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Col>

          {/* Content */}
          <Col lg="10">
            <TabContent activeTab={activeTab} className="sec-tab-content">

              <OverviewTab settings={settingsData} loginLogs={loginLogsData} activeDevices={activeDevices} />

              <AuthenticationTab settings={settingsData} />

              <SessionsTab activeDevices={activeDevices} refreshData={getSettings} />

              <LoginTab settings={settingsData} />

              <AccessControl />

              <AuditTab data={loginLogsData} />

            </TabContent>
          </Col>
        </Row>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default SecurityPage;
